// src/pages/Dashboard.jsx
// الصفحة الرئيسية — نفس ترويسة القوائم (MenuHeader) ومربعات الأقسام بحجم أكبر، مع دعم الترجمة

import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";

import CategoryIcon from "@mui/icons-material/Category";
import TuneIcon from "@mui/icons-material/Tune";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import WbSunnyOutlinedIcon from "@mui/icons-material/WbSunnyOutlined";
import NightsStayOutlinedIcon from "@mui/icons-material/NightsStayOutlined";
import EventIcon from "@mui/icons-material/Event";

import { MenuHeader, MenuCard, useMenuT } from "../../components/Menu/MenuKit";
const MODULES = [
  { key: "sales", nameKey: "dashboard.sales", nameFallback: "المبيعات", icon: <StorefrontOutlinedIcon />, color: "#4F46E5", link: "/sales-menu" },
  { key: "pos", nameKey: "dashboard.pos", nameFallback: "نقطة البيع", icon: <PointOfSaleIcon />, color: "#7C3AED", link: "/pos" },
  { key: "purchases", nameKey: "dashboard.purchases", nameFallback: "المشتريات", icon: <ShoppingCartOutlinedIcon />, color: "#E11D48", link: "/purchases-menu" },
  { key: "warehouses", nameKey: "dashboard.warehouses", nameFallback: "المستودعات", icon: <WarehouseIcon />, color: "#059669", link: "/warehouses-menu" },
  { key: "accounting", nameKey: "dashboard.accounting", nameFallback: "المحاسبة", icon: <AccountBalanceIcon />, color: "#2563EB", link: "/accounts-menu" },
  { key: "definitions", nameKey: "dashboard.definitions", nameFallback: "التعاريف", icon: <CategoryIcon />, color: "#0891B2", link: "/company-definitions" },
  { key: "settings", nameKey: "dashboard.generalSettings", nameFallback: "الإعدادات", icon: <TuneIcon />, color: "#DB2777", link: "/settings-menu" },
];

export default function Dashboard() {
  const navigate = useNavigate();
  const { tr, dir, lang } = useMenuT();

  const userName = localStorage.getItem("userName") || "";
  const companyName = localStorage.getItem("companyName") || tr("dashboard.title", "لوحة التحكم الرئيسية");

  const hour = new Date().getHours();
  const morning = hour >= 4 && hour < 12;
  const greeting = morning ? tr("dashboard.goodMorning", "صباح الخير") : tr("dashboard.goodEvening", "مساء الخير");
  const eyebrow = userName ? `${greeting}${lang === "en" ? ", " : "، "}${userName}` : greeting;

  const today = new Date().toLocaleDateString(lang === "en" ? "en-GB" : "ar-SA-u-ca-gregory-nu-latn", {
    weekday: "long", day: "numeric", month: "long", year: "numeric",
  });

  return (
    <Box dir={dir} sx={{ px: { xs: 1, sm: 2, md: 3 }, py: { xs: 1, md: 2 } }}>
      <MenuHeader
        icon={morning ? <WbSunnyOutlinedIcon /> : <NightsStayOutlinedIcon />}
        eyebrow={eyebrow}
        title={companyName}
  >
        <Box sx={{
          display: "inline-flex", alignItems: "center", gap: .75, px: 1.5, py: .75, borderRadius: "11px",
          bgcolor: "rgba(255,255,255,.14)", border: "1px solid rgba(255,255,255,.28)", fontSize: 14, fontWeight: 700,
          "& svg": { fontSize: 18 },
        }}>
          <EventIcon />{today}
        </Box>
      </MenuHeader>



      <Box sx={{
        display: "grid", gap: { xs: 1, sm: 1.5 },
        gridTemplateColumns: { xs: "repeat(2, minmax(0,1fr))", sm: "repeat(3, minmax(0,1fr))", md: "repeat(4, minmax(0,1fr))" },
      }}>
        {MODULES.map(m => <MenuCard key={m.key} item={m} size="lg" onClick={() => navigate(m.link)} />)}
      </Box>
    </Box>
  );
}